// Sidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {Dashboard, Person, People, Business, LocalShipping} from '@mui/icons-material';
import './Sidebar.css';
import { roles } from "../../pages/utils/constant";
import { BillingIcon, CustomerIcon, DeliveryBoyIcon, DocketIcon, DRSIcon, InscanIcon, ManifestIcon, OfficeIcon } from '../Icons';

const Sidebar = ({ isCollapsed }) => {
  const location = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const setSidebar =()=> {
    switch (userDetails?.Role) {
      case roles.Admin:
        return (
          <>
            <div className='side-nav-list'>
              <Link to="/dashboard/customerlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/customerlist") ? "selected" : ""}`}>
                <CustomerIcon color={location.pathname.startsWith("/dashboard/customerlist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Customer Management</span>}
              </Link>
            </div>

            {/* ================== Office Management ===================== */}
            <div className='side-nav-list'>
              <Link to="/dashboard/officelist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/officelist") ? "selected" : ""}`}>
                <OfficeIcon color={location.pathname.startsWith("/dashboard/officelist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Office Management</span>}
              </Link>
            </div>
           
            {/*=============== Branch Management =============*/}
            {/* <div className='side-nav-list'>
              <Link to="/dashboard/branchlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/branchlist") ? "selected" : ""}`}>
                <Business color={location.pathname.startsWith("/dashboard/branchlist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Branch Management</span>}
              </Link>
            </div> */}

        {/*=============== Delivery Boy Management =============*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/deliveryboylist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/deliveryboylist") ? "selected" : ""}`}>
                <DeliveryBoyIcon color={location.pathname.startsWith("/dashboard/deliveryboylist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Delivery Boy</span>}
              </Link>
            </div>

            {/*================ PickUp Management ============ */}
            <div className='side-nav-list'>
              <Link to="/dashboard/pickuplist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/pickuplist") ? "selected" : ""}`}>
                <LocalShipping />
                {!isCollapsed && <span className="list-item-name">Pickup Management</span>}
              </Link>
            </div>

          {/* =================== Docket Management ============== */}
            <div className='side-nav-list'>
              <Link to="/dashboard/docketlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/docketlist") ? "selected" : ""}`}>
                <DocketIcon color={location.pathname.startsWith("/dashboard/docketlist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Docket Management</span>}
              </Link>
            </div>

          {/*================ Manifest Management ======================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/manifestList" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/manifestList") ? "selected" : ""}`}>
                <ManifestIcon color={location.pathname.startsWith("/dashboard/manifestList") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Manifest Management</span>}
              </Link>
            </div>

            {/* ================ Inscan Management ======================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/viewlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/viewlist") ? "selected" : ""}`}>
                <InscanIcon color={location.pathname.startsWith("/dashboard/viewlist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Inscan Management</span>}
              </Link>
            </div>

            {/* =============== DRS Management ===================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/drslist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/drslist") ? "selected" : ""}`}>
                <DRSIcon color={location.pathname.startsWith("/dashboard/drslist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Delivery Run Sheet</span>}
              </Link>
            </div>

            {/* =================== POD ============== */} 
           <div className='side-nav-list'>
              <Link to="/dashboard/podlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/podlist") ? "selected" : ""}`}>
                {/* <DocketIcon color={location.pathname.startsWith("/dashboard/podlist") ? "primary" : "#FFFFFF"}/> */}
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2.7 18L15.3 18C16.7912 18 18 16.7912 18 15.3V9.90116V9.9V9.89884L18 2.7C18 1.20883 16.7912 0 15.3 0H2.7C1.20883 0 0 1.20883 0 2.7V15.3C1.7683e-06 16.7912 1.20883 18 2.7 18ZM16.2 9L16.2 2.7C16.2 2.20294 15.7971 1.8 15.3 1.8L2.7 1.8C2.20295 1.8 1.8 2.20294 1.8 2.7L1.8 9H16.2ZM16.2 10.8H1.8L1.8 15.3C1.8 15.7971 2.20295 16.2 2.7 16.2L15.3 16.2C15.7971 16.2 16.2 15.7971 16.2 15.3V10.8ZM3.6 4.5C3.6 4.00294 4.00294 3.6 4.5 3.6H9C9.49706 3.6 9.9 4.00294 9.9 4.5C9.9 4.99706 9.49706 5.4 9 5.4H4.5C4.00294 5.4 3.6 4.99706 3.6 4.5ZM11.7 3.6C11.2029 3.6 10.8 4.00294 10.8 4.5C10.8 4.99706 11.2029 5.4 11.7 5.4H12.6C13.0971 5.4 13.5 4.99706 13.5 4.5C13.5 4.00294 13.0971 3.6 12.6 3.6H11.7Z" fill={location.pathname.startsWith("/dashboard/podlist") ? "primary" : "#FFFFFF"}/>
                  </svg>
                {!isCollapsed && <span className="list-item-name">POD</span>}
              </Link>
            </div>

          {/* ================= Bill Management ======================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/billinglist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/billinglist") ? "selected" : ""}`}>
                <BillingIcon color={location.pathname.startsWith("/dashboard/billinglist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Billing Management</span>}
              </Link>
            </div>

          {/* =============  Reports  =========================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/reportlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/reportlist") ? "selected" : ""}`}>
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M13 4C13 5.10457 12.1046 6 11 6H5C3.89543 6 3 5.10457 3 4C2.44772 4 2 4.44772 2 5V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V5C14 4.44772 13.5523 4 13 4ZM6 0C4.69378 0 3.58254 0.834808 3.17071 2H3C1.34314 2 0 3.34315 0 5V17C0 18.6569 1.34314 20 3 20H13C14.6569 20 16 18.6569 16 17V5C16 3.34315 14.6569 2 13 2H12.8293C12.4175 0.834807 11.3062 0 10 0H6ZM6 4H5V3C5 2.44772 5.44772 2 6 2H10C10.5523 2 11 2.44772 11 3V4H10H9H7H6ZM10.2803 8.21967C9.98744 7.92678 9.51256 7.92678 9.21967 8.21967L4.21967 13.2197C4.07902 13.3603 4 13.5511 4 13.75V15.25C4 15.6642 4.33579 16 4.75 16H6.25C6.44891 16 7.63968 14.921 7.78033 14.7803L11.7803 10.7803C12.0732 10.4874 12.0732 10.0126 11.7803 9.71967L10.2803 8.21967Z" fill={location.pathname.startsWith("/dashboard/reportlist") ? "primary" : "#FFFFFF"}/>
                </svg>
                {!isCollapsed && <span className="list-item-name">Reports</span>}
              </Link>
            </div>

          {/* =============  Delivery Management  =========================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/deliverymanagement" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/deliverymanagement") ? "selected" : ""}`}>
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M13 4C13 5.10457 12.1046 6 11 6H5C3.89543 6 3 5.10457 3 4C2.44772 4 2 4.44772 2 5V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V5C14 4.44772 13.5523 4 13 4ZM6 0C4.69378 0 3.58254 0.834808 3.17071 2H3C1.34314 2 0 3.34315 0 5V17C0 18.6569 1.34314 20 3 20H13C14.6569 20 16 18.6569 16 17V5C16 3.34315 14.6569 2 13 2H12.8293C12.4175 0.834807 11.3062 0 10 0H6ZM6 4H5V3C5 2.44772 5.44772 2 6 2H10C10.5523 2 11 2.44772 11 3V4H10H9H7H6ZM10.2803 8.21967C9.98744 7.92678 9.51256 7.92678 9.21967 8.21967L4.21967 13.2197C4.07902 13.3603 4 13.5511 4 13.75V15.25C4 15.6642 4.33579 16 4.75 16H6.25C6.44891 16 7.63968 14.921 7.78033 14.7803L11.7803 10.7803C12.0732 10.4874 12.0732 10.0126 11.7803 9.71967L10.2803 8.21967Z" fill={location.pathname.startsWith("/dashboard/deliverymanagement") ? "primary" : "#FFFFFF"}/>
                </svg>
                {!isCollapsed && <span className="list-item-name">Delivery Management</span>}
              </Link>
            </div>


          </>
      )

      case roles.OfficeAdmin:
        return (
          <>
          <div className='side-nav-list'>
              <Link to="/dashboard/createform" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/createform") ? "selected" : ""}`}>
                <LocalShipping />
                {!isCollapsed && <span className="list-item-name">Pickup Management</span>}
              </Link>
            </div>
             <div className='side-nav-list'>
              <Link to="/dashboard/manifestList" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/manifestList") ? "selected" : ""}`}>
                <ManifestIcon color={location.pathname.startsWith("/dashboard/manifestList") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Manifest Management</span>}
              </Link>
            </div>
            <div className='side-nav-list'>
              <Link to="/dashboard/viewlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/viewlist") ? "selected" : ""}`}>
                <InscanIcon color={location.pathname.startsWith("/dashboard/viewlist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">Inscan Management</span>}
              </Link>
            </div>
            <div className='side-nav-list'>
              <Link to="/dashboard/drslist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/drslist") ? "selected" : ""}`}>
                <DRSIcon color={location.pathname.startsWith("/dashboard/drslist") ? "primary" : "#FFFFFF"}/>
                {!isCollapsed && <span className="list-item-name">DRS Management</span>}
              </Link>
            </div>

          {/* =================== POD ============== */}
            <div className='side-nav-list'>
              <Link to="/dashboard/podlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/podlist") ? "selected" : ""}`}>
                {/* <DocketIcon color={location.pathname.startsWith("/dashboard/podlist") ? "primary" : "#FFFFFF"}/> */}
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2.7 18L15.3 18C16.7912 18 18 16.7912 18 15.3V9.90116V9.9V9.89884L18 2.7C18 1.20883 16.7912 0 15.3 0H2.7C1.20883 0 0 1.20883 0 2.7V15.3C1.7683e-06 16.7912 1.20883 18 2.7 18ZM16.2 9L16.2 2.7C16.2 2.20294 15.7971 1.8 15.3 1.8L2.7 1.8C2.20295 1.8 1.8 2.20294 1.8 2.7L1.8 9H16.2ZM16.2 10.8H1.8L1.8 15.3C1.8 15.7971 2.20295 16.2 2.7 16.2L15.3 16.2C15.7971 16.2 16.2 15.7971 16.2 15.3V10.8ZM3.6 4.5C3.6 4.00294 4.00294 3.6 4.5 3.6H9C9.49706 3.6 9.9 4.00294 9.9 4.5C9.9 4.99706 9.49706 5.4 9 5.4H4.5C4.00294 5.4 3.6 4.99706 3.6 4.5ZM11.7 3.6C11.2029 3.6 10.8 4.00294 10.8 4.5C10.8 4.99706 11.2029 5.4 11.7 5.4H12.6C13.0971 5.4 13.5 4.99706 13.5 4.5C13.5 4.00294 13.0971 3.6 12.6 3.6H11.7Z" fill={location.pathname.startsWith("/dashboard/podlist") ? "primary" : "#FFFFFF"}/>
                  </svg>
                {!isCollapsed && <span className="list-item-name">POD</span>}
              </Link>
            </div>

            {/* =============  Reports  =========================*/}
            <div className='side-nav-list'>
              <Link to="/dashboard/reportlist" className={`side-nav-list-item ${location.pathname.startsWith("/dashboard/reportlist") ? "selected" : ""}`}>
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M13 4C13 5.10457 12.1046 6 11 6H5C3.89543 6 3 5.10457 3 4C2.44772 4 2 4.44772 2 5V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V5C14 4.44772 13.5523 4 13 4ZM6 0C4.69378 0 3.58254 0.834808 3.17071 2H3C1.34314 2 0 3.34315 0 5V17C0 18.6569 1.34314 20 3 20H13C14.6569 20 16 18.6569 16 17V5C16 3.34315 14.6569 2 13 2H12.8293C12.4175 0.834807 11.3062 0 10 0H6ZM6 4H5V3C5 2.44772 5.44772 2 6 2H10C10.5523 2 11 2.44772 11 3V4H10H9H7H6ZM10.2803 8.21967C9.98744 7.92678 9.51256 7.92678 9.21967 8.21967L4.21967 13.2197C4.07902 13.3603 4 13.5511 4 13.75V15.25C4 15.6642 4.33579 16 4.75 16H6.25C6.44891 16 7.63968 14.921 7.78033 14.7803L11.7803 10.7803C12.0732 10.4874 12.0732 10.0126 11.7803 9.71967L10.2803 8.21967Z" fill={location.pathname.startsWith("/dashboard/reportlist") ? "primary" : "#FFFFFF"}/>
                </svg>
                {!isCollapsed && <span className="list-item-name">Reports</span>}
              </Link>
            </div>
          </>
        );
  
        default:
          return null;
    }
  }

  return (
    <div style={{ background: "#04AB44" }} className={isCollapsed ? "collapsed-sideNav" : "sideNav"}>
       <div className='side-nav-list' style={{margin:'10px', display: 'flex', flexDirection: 'column', paddingTop: '75px', gap:4 }}>
          <Link to="/dashboard" className={`side-nav-list-item ${location.pathname === "/dashboard" ? "selected" : ""}`}>
            <Dashboard sx={{height:'22px', width:'22px'}}/>
            {!isCollapsed && <span className="list-item-name">Dashboard</span>}
          </Link>
        {setSidebar()}
      </div>
    </div>

  );
};

export default Sidebar;
